import dynamic from 'next/dynamic';
import { EventListProps } from './EventList.types';

const EventListBau = dynamic<{ model: EventListProps }>(() => import('./EventList').then(mod => mod.EventList));

const EventListDtt = dynamic<{ model: EventListProps }>(() => import('./EventListDtt').then(mod => mod.EventListDtt));

export const EventList = (isDtt: boolean) => (isDtt ? EventListDtt : EventListBau);
